import { render, staticRenderFns } from "./BankInformations.vue?vue&type=template&id=3b325f8d&"
import script from "./BankInformations.vue?vue&type=script&lang=js&"
export * from "./BankInformations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports